import React, { FunctionComponent } from 'react';
import compose from 'recompose/compose';
import pure from 'recompose/pure';
import { HotelSegmentDetails } from '../../../models/itinerary';
import { Distance } from '../Distance';
import { StarRating } from '../StarRating';
import { ColumnSecondaryText } from '../TextStyles/ColumnSecondaryText';
import { ProviderNameText } from '../TextStyles/ProviderNameText';

interface OwnProps {
  address: string;
  distanceInKm?: number;
  location: string;
  providerName: HotelSegmentDetails['chainName'];
  reviewCount?: number;
  starRating?: HotelSegmentDetails['starRating'];
  isSaviSelectIntl: boolean;
  nation?: string
}

interface HotelProviderDetailsProps extends OwnProps {}

const HotelProviderDetailsBase: FunctionComponent<
  HotelProviderDetailsProps
> = ({
  address,
  nation,
  distanceInKm,
  location,
  reviewCount,
  starRating,
  providerName,
  isSaviSelectIntl
}) => (
  <>
    {!isSaviSelectIntl && <ProviderNameText>{providerName}</ProviderNameText> }
    <ColumnSecondaryText>{address}</ColumnSecondaryText>
    {isSaviSelectIntl && nation && nation.length > 0 && <ColumnSecondaryText>{nation}</ColumnSecondaryText> }
    {!!distanceInKm && (
      <Distance distanceInKm={distanceInKm} location={location} />
    )}
    {!!starRating && (
      <StarRating value={starRating} reviewCount={reviewCount} />
    )}
  </>
);

const enhance = compose<HotelProviderDetailsProps, OwnProps>(pure);

/**
 * Hotel provider details
 *
 * @example
 *
 * "Vantis Hotel Group"
 * "1 Hobson St Downtown, Nor..."
 * "📍 0.43km from CB"
 */
export const HotelProviderDetails = enhance(HotelProviderDetailsBase);

HotelProviderDetails.displayName = 'HotelProviderDetails';
